<template>
  <ModalWrapper
    classes="z-10 [&>.modal]:min-h-full [&>.modal]:flex [&>.modal]:flex-col"
    :closeButton="false"
    :visible="isKYCModalOpen"
    @close="closeKYCModal">
    <template #custom>
      <div class="flex flex-1 flex-col justify-between gap-[30px] px-2.5 pb-5">
        <div class="flex flex-col gap-[30px]">
          <div class="flex flex-col gap-3 text-balance">
            <div class="text-2xl leading-[1.35] font-bold text-text-1 text-balance">
              {{ $t("profile|verification") }}
            </div>
            <div class="text-base leading-[1.5] font-medium text-text-6">
              {{ $t("profile|threeSteps") }}
            </div>
          </div>
          <div class="flex flex-col gap-[30px]">
            <div v-for="step in steps" :key="step.number" class="flex items-start gap-4">
              <div
                class="shrink-0 flex justify-center items-center w-12 h-12 rounded-full bg-back-3 text-lg leading-[1.5] font-bold text-white">
                {{ step.number }}
              </div>
              <div class="flex flex-col gap-1.5 leading-[1.5]">
                <div class="text-lg font-bold text-text-1">{{ t(step.title) }}</div>
                <div class="text-sm font-medium text-text-6">{{ t(step.description) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div
            class="rounded-xl bg-back-3 p-4 text-xs leading-[1.5] font-medium text-text-6 text-center">
            {{ $t("profile|thirdPartyVerification") }}
          </div>
          <BaseButton size="lg" @click="openKYCWidgetAndCloseModals">
            {{ $t("profile|passVerificationButton") }}
          </BaseButton>
        </div>
      </div>
    </template>
  </ModalWrapper>
  <ModalWrapper
    classes="z-10 [&>.modal]:min-h-full [&>.modal]:flex [&>.modal]:flex-col"
    :closeButton="false"
    :visible="isKYCShortModalOpen"
    @close="closeKYCShortModal">
    <template #custom>
      <div class="flex flex-1 flex-col gap-4 px-2.5">
        <div class="flex flex-1 flex-col items-center justify-center gap-6 text-center">
          <img :src="kycImage" alt="" class="w-[180px] h-[180px]" />
          <div class="flex flex-col items-center gap-3 text-balance px-6">
            <div class="text-2xl leading-[1.35] font-bold text-text-1 text-balance">
              {{ $t("profile|verificationNeeded") }}
            </div>
            <div class="max-w-[311px] text-sm leading-[1.5] font-medium text-text-6">
              {{ $t("profile|KYCNeededDesc") }}
            </div>
          </div>
        </div>
        <BaseButton size="lg" @click="openKYCWidgetAndCloseModals">
          {{ $t("profile|passVerificationButton") }}
        </BaseButton>
      </div>
    </template>
  </ModalWrapper>
  <ModalWrapper
    classes="z-10 [&>.modal]:min-h-full [&>.modal]:flex [&>.modal]:flex-col"
    :closeButton="false"
    :visible="isKYCPendingModalOpen"
    @close="closeKYCPendingModal">
    <template #custom>
      <div class="flex flex-1 flex-col justify-center px-2.5 pb-5">
        <KYCProfileBlock :isBorder="false" openWidgetDirectly />
      </div>
    </template>
  </ModalWrapper>
  <KYC />
</template>

<script setup>
import { computed, watch } from "vue";
import ModalWrapper from "@/components/ui/modal/modalWrapper.vue";
import KYC from "@/views/KYC/KYC.vue";
import { useKycStore } from "@/stores/kyc";
import { useI18n } from "vue-i18n";
import BaseButton from "@emcd-shared/base-button";
import { useRouter } from "vue-router";
import KYCProfileBlock from "./KYCProfileBlock.vue";
import kycImage from "@/views/Card/assets/images/kyc_main.png";

const { t } = useI18n();

const steps = [
  {
    title: "profile|chooseDocument",
    description: "profile|selectDocument",
    number: 1,
  },
  {
    title: "profile|takePicture",
    description: "profile|takePictureDesc",
    number: 2,
  },
  {
    title: "profile|makeSelfie",
    description: "profile|makeSelfieDesc",
    number: 3,
  },
];

const kycStore = useKycStore();
const router = useRouter();

const isKYCModalOpen = computed(() => kycStore.getIsKYCModalOpen());
const isKYCShortModalOpen = computed(() => kycStore.getIsKYCShortModalOpen());
const isKYCPendingModalOpen = computed(() => kycStore.getIsKYCPendingModalOpen());

const openKYCWidget = () => {
  kycStore.setIsKYCWidgetOpen(true);
};

const openKYCWidgetAndCloseModals = () => {
  openKYCWidget();
  kycStore.setIsKYCModalOpen(false);
  kycStore.setIsKYCShortModalOpen(false);
};

const closeKYCModal = () => {
  kycStore.setIsKYCModalOpen(false);
};

const closeKYCShortModal = () => {
  kycStore.setIsKYCShortModalOpen(false);
};

const closeKYCPendingModal = () => {
  kycStore.setIsKYCPendingModalOpen(false);
};

// The widget itself is closed on route change by KYC.vue
watch(router.currentRoute, () => {
  closeKYCModal();
});
</script>
